import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../providers/AuthProvider'
import { useMsal } from '@azure/msal-react'

const LogoutPage = () => {
  const navigate = useNavigate()
  const { instance } = useMsal()
  const { authState, setAuthState } = useAuth()

  useEffect(() => {
    const performLogout = async () => {
      try {
        const wasMicrosoftLogin = authState.loginMethod === 'microsoft'
        const username = wasMicrosoftLogin ? instance?.getAllAccounts()[0]?.username : null
        const logoutMethod = wasMicrosoftLogin ? 'microsoft' : 'manual'
        const logoutLabel = username ? `${logoutMethod} logout (${username})` : `${logoutMethod} logout`

        console.info(`${logoutLabel} attempt`)

        setAuthState({ accessToken: null, loginMethod: '', isLoggedIn: false, loggingOut: true })
        localStorage.removeItem('accessToken')
        localStorage.removeItem('loginMethod')

        if (instance && wasMicrosoftLogin) {
          await instance.logoutPopup({
            mainWindowRedirectUri: window.location.origin + '/login'
          })
        }

        setAuthState({ accessToken: null, loginMethod: '', isLoggedIn: false, loggingOut: false })
        console.info(`${logoutLabel} succeeded`)
        navigate('/login', { replace: true })
      } catch (err) {
        console.error('Error during logout:', err)
      }
    }

    performLogout()
  }, [instance, navigate, setAuthState])

  return null
}

export default LogoutPage
